import axios, { AxiosResponse } from "axios";
import { SERVER_URL } from "Constants";
import { CustomerAuditFilterParams, CUSTOMER_AUDITS_PAGE_LENGTH } from "Views/Components/Intel/Customer/CustomerAudits/Gibs/FetchCustomerAudits";
import { EntityControllerData } from "./shared";
import { customerAuditCategory, auditCategory } from "Models/Enums";

// Customer Audit and Monitor Audit categories
export type CombinedCustomerAuditCategory  =  customerAuditCategory | auditCategory;

export interface CustomerAuditEntryModel {
	id: string,
	customerId: string,
	description: CustomerAuditDescription;
	category:  CombinedCustomerAuditCategory;
	created: Date;
	modified: Date;
	updatedBy: string;
}

export interface CustomerAuditDescription {
	title: string;
	message?: string;
}

export async function requestCombinedCustomerAudits(
	customerId: string,
	search: string,
	auditFilterParams: CustomerAuditFilterParams,
	page: number
): Promise<AxiosResponse<EntityControllerData<CustomerAuditEntryModel>>> {
	
	const url = `${SERVER_URL}/api/entity/CustomerAuditEntity/combined`;

	const body = {
		customerId,
		search,
		auditFilterParams,
		page,
		pageSize: CUSTOMER_AUDITS_PAGE_LENGTH
	}

	return  await axios.post<EntityControllerData<CustomerAuditEntryModel>>(url, body);
};